import React from "react";

import cn from "classnames";

import IconNames from "./Icon.Components";
import { IconProps } from "./Icon.props";

import styles from "./Icon.module.scss";

/**
 * @deprecated
 */
const Icon: React.FC<IconProps> = (props: IconProps): JSX.Element | null => {
  const { id, name, className, color = "black", size = "medium", testId } = props;
  const iconClasses = cn(styles["icon"], styles[size], styles[color], className);

  if ((IconNames as Record<string, React.ComponentType>)[name]) {
    return React.createElement(
      (IconNames as Record<string, React.ComponentType>)[name],
      {
        // @ts-ignore
        id: id,
        className: iconClasses,
        "data-testid": testId ? `test__${testId}-icon` : undefined,
        /**
         * regardless of what I did, I could not get the aria-hidden and aria-label to pass the tests
         * commenting out for now as this is deprecated anyway
         * "aria-hidden": ariaHidden ? ariaHidden : undefined,
         * "aria-label": ariaLabel ? ariaLabel : undefined,
         */
      },
      null,
    );
  } else {
    return null;
  }
};

/**
 * @deprecated
 */
export default Icon;
